export enum IndicationEnum {
    Yes = 'J',
    No = 'N',
}
